export const FormuleType = Object.freeze({
    PREPA_ANNUELLE: "90001",
    TUTORAT_INDIVIDUEL: "80001",
    FORMULES_2_3_4_STAGES: "80003",
    SCIENCES_PO_PARIS_SEUL: "7004",
    CONCOURS_COMMUN_SEUL: "7001",
    COMBINE_SC_PO_PARIS_IEP: "7002",
    FORMULE_WEEK_ENDS: "7003",
    STAGES_CARTE: "7000",
});

export function getFormuleTypeLabel(formuleType) {
    switch (formuleType) {
        case FormuleType.TUTORAT_INDIVIDUEL:
            return 'Tutorat individuel';
        case FormuleType.SCIENCES_PO_PARIS_SEUL:
            return 'Sciences Po Paris seul';
        case FormuleType.CONCOURS_COMMUN_SEUL:
            return 'Concours commun seul';
        case FormuleType.COMBINE_SC_PO_PARIS_IEP:
            return 'Combiné Sc. Po Paris + IEP';
        case FormuleType.FORMULE_WEEK_ENDS:
            return 'Formule week-ends';
        case FormuleType.STAGES_CARTE:
            return 'Stages à la carte';
        case FormuleType.FORMULES_2_3_4_STAGES:
            return 'Formules 2,3,4 stages';
        case FormuleType.PREPA_ANNUELLE:
            return 'Prépa annuelle';
        default:
            return 'Autre';
    }
}